import { XSDAssemblerBuilder } from './XSDAssemblerBuilder';

const xsdAssemblerBuilder = new XSDAssemblerBuilder();

export default xsdAssemblerBuilder;
